import { combineReducers, configureStore } from '@reduxjs/toolkit'
import userProfileReducer from './userProfile'

//combine all reducers
const rootReducer = combineReducers({
  userProfile: userProfileReducer,
})

// This is useful for test setup or customized initial state
export const setUpStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }),
  })
}

const store = setUpStore()

export const dispatch = store.dispatch

export default store
